module.exports = __webpack_public_path__ + "static/media/PDF-04.58c10fff.webp";